import React from 'react';
import * as _ from 'lodash';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { Checkbox, Typography } from '@mui/material';
import { DatePicker } from '@bld/bld-libs/components';
import { TARGET_PARTNER_COMPANY_TYPE } from '@bld/bld-libs/constants';

import { PUBLICATION_STATUS } from '../../utilities/constants';
import { messageUtility } from '../../utilities/messageUtility';

import Styles from '../../styles/componentStyle/fieldBulletinBoard/FieldBulletinBoardForm.scss';

/**
 * 現場掲示板 公開設定
 * @param {  }data
 * @param {  }handleChangeData
 * @param {  }validateFormItem
 * @param {  }formErrorMessage
 * @returns { JSX.Element }
 */
export function FieldBulletinBoardPublishSettings({
  data,
  handleChangeData,
  usageEndDate,
  validateFormItem,
  formErrorMessage,
}) {
  const isNotDraft =
    _.has(data, 'bulletin_board_publication_status') &&
    data.bulletin_board_publication_status != PUBLICATION_STATUS.DRAFT.id;

  return (
    <React.Fragment>
      <div className={`${Styles.publishSettings}`}>
        <div className='form-group'>
          <h1 className='form__title'>
            {messageUtility.getMessage('I-000-165-18')}
          </h1>
          <div className='bulletin-board-form-list'>
            <div className='form-item'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-19')}
                <span className='form__required'>
                  {messageUtility.getMessage('I-000-165-17')}
                </span>
              </span>
              <div>
                <DatePicker
                  value={data.publication_start_at}
                  sx={{ '.MuiSvgIcon-root ': { fill: '#2681ff' } }}
                  onChange={date => {
                    handleChangeData({
                      publication_start_at: date,
                    });
                    validateFormItem('publication_start_at');
                  }}
                  error={
                    _.has(formErrorMessage, 'publication_start_at') &&
                    !_.isEmpty(formErrorMessage.publication_start_at)
                  }
                  disabled={isNotDraft}
                  isRequired
                  placeholder={messageUtility.getMessage('I-000-165-16')}
                />
                {_.has(formErrorMessage, 'publication_start_at') &&
                  !_.isEmpty(formErrorMessage.publication_start_at) && (
                    <Typography
                      color='error'
                      sx={{ fontSize: '0.75rem', margin: '4px 14px 0px 14px' }}
                    >
                      {formErrorMessage.publication_start_at}
                    </Typography>
                  )}
              </div>
            </div>
            <div className='form-item'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-20')}
                <span className='form__required'>
                  {messageUtility.getMessage('I-000-165-17')}
                </span>
              </span>
              <FormControl>
                <RadioGroup
                  row
                  value={data.target_partner_company_type}
                  onChange={event =>
                    handleChangeData({
                      target_partner_company_type: event.target.value,
                    })
                  }
                  onBlur={() => validateFormItem('target_partner_company_type')}
                  sx={{ '.MuiSvgIcon-root': { fill: '#2681ff' } }}
                >
                  <FormControlLabel
                    value={TARGET_PARTNER_COMPANY_TYPE.ALL.TYPE_NUMBER}
                    control={<Radio />}
                    label={messageUtility.getMessage('I-000-165-21')}
                    sx={{ '.MuiTypography-root': { fontSize: 13 } }}
                    disabled={isNotDraft}
                  />
                  <FormControlLabel
                    value={TARGET_PARTNER_COMPANY_TYPE.ONLYFIRST.TYPE_NUMBER}
                    control={<Radio />}
                    label={messageUtility.getMessage('I-000-165-22')}
                    sx={{ '.MuiTypography-root': { fontSize: 13 } }}
                    disabled={isNotDraft}
                  />
                </RadioGroup>
              </FormControl>
            </div>
            <div className='form-item'>
              <span className='form__label'>
                {messageUtility.getMessage('I-000-165-23')}
              </span>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{
                      '.MuiSvgIcon-root': { fontSize: 24, fill: '#2681ff' },
                    }}
                  />
                }
                onChange={event =>
                  handleChangeData({ is_send_mail: event.target.checked })
                }
                checked={data.is_send_mail}
                label={messageUtility.getMessage('I-000-165-24')}
                sx={{ '.MuiTypography-root': { fontSize: 13 } }}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/fieldBulletinBoard/FieldBulletinBoardPublishSettings.jsx